module.exports = __webpack_public_path__ + "media/images/slovakia-2fb724d5a1a11ff9898f9bc11042813f.svg";